import FiltersBlock from './FiltersBlock';
import { FiltersBlockProps, FiltersBlockValueProps } from './types';

export type { FiltersBlockProps, FiltersBlockValueProps };
export default FiltersBlock;
